import { render, staticRenderFns } from "./UnfilledRequests.vue?vue&type=template&id=e820fcee&scoped=true&"
import script from "./UnfilledRequests.vue?vue&type=script&lang=js&"
export * from "./UnfilledRequests.vue?vue&type=script&lang=js&"
import style0 from "./UnfilledRequests.vue?vue&type=style&index=0&id=e820fcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e820fcee",
  null
  
)

export default component.exports